(function () {
  var SPLIDE_SELECTOR = '.babybjorn-product-videos__splide';

  function getSplideOptions() {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var padKey = rtl ? 'left' : 'right';
    var peek = {};
    peek[padKey] = '6.25%';
    var peekMd = {};
    peekMd[padKey] = '10%';
    var peekSm = {};
    peekSm[padKey] = '14%';

    return {
      type: 'slide',
      direction: rtl ? 'rtl' : 'ltr',
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      padding: peek,
      pagination: false,
      arrows: false,
      drag: true,
      rewind: false,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
      breakpoints: {
        989: {
          perPage: 2,
          padding: peekMd,
          gap: '0.85rem',
        },
        749: {
          perPage: 1,
          padding: peekSm,
          gap: '0.65rem',
        },
      },
    };
  }

  function syncArrows(splide, prevBtn, nextBtn) {
    if (!splide || !splide.Components || !splide.Components.Controller) return;
    var end = 0;
    try {
      end = splide.Components.Controller.getEnd();
    } catch (e) {
      return;
    }
    var i = splide.index;
    if (prevBtn) {
      prevBtn.disabled = i <= 0;
    }
    if (nextBtn) {
      nextBtn.disabled = i >= end;
    }
  }

  function mountSplide(el) {
    if (!el || el.dataset.bbjSplideReady === '1') return;
    if (typeof Splide === 'undefined') return;

    var root = el.closest('[data-bbj-product-videos]');
    var prevBtn = root && root.querySelector('[data-bbj-pv-prev]');
    var nextBtn = root && root.querySelector('[data-bbj-pv-next]');

    var splide = new Splide(el, getSplideOptions());
    splide.mount();
    el._babybjornSplide = splide;
    el.dataset.bbjSplideReady = '1';

    function refreshLayout() {
      try {
        splide.refresh();
      } catch (e) {
        /* noop */
      }
    }

    refreshLayout();

    var onPrev = function (e) {
      e.preventDefault();
      splide.go('<');
    };
    var onNext = function (e) {
      e.preventDefault();
      splide.go('>');
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrev);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', onNext);
    }

    var update = function () {
      syncArrows(splide, prevBtn, nextBtn);
    };
    splide.on('mounted moved resized updated', update);
    update();

    el._babybjornSplideCleanup = function () {
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      splide.destroy();
      delete el._babybjornSplide;
      delete el._babybjornSplideCleanup;
      delete el.dataset.bbjSplideReady;
    };
  }

  function destroySplideIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SPLIDE_SELECTOR).forEach(function (el) {
      if (el._babybjornSplideCleanup) {
        el._babybjornSplideCleanup();
      }
    });
  }

  function scheduleMount(root) {
    var target = root || document;
    queueMicrotask(function () {
      if (typeof Splide === 'undefined') {
        requestAnimationFrame(function () {
          if (typeof Splide !== 'undefined') {
            target.querySelectorAll(SPLIDE_SELECTOR).forEach(mountSplide);
          }
        });
        return;
      }
      target.querySelectorAll(SPLIDE_SELECTOR).forEach(mountSplide);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bbjVideosBound === '1') return;
    root.dataset.bbjVideosBound = '1';

    var modal = root.querySelector('[data-bbj-video-modal]');
    var embed = root.querySelector('[data-bbj-video-embed]');

    if (modal && embed) {
      function onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeModal();
        }
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('hidden', '');
        var playing = embed.querySelector('video');
        if (playing) {
          playing.pause();
        }
        embed.innerHTML = '';
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', onKeydown);
      }

      root.querySelectorAll('[data-bbj-video-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-video-url');
          if (!url) return;
          var video = document.createElement('video');
          video.setAttribute('controls', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('preload', 'auto');
          video.setAttribute('src', url);
          embed.innerHTML = '';
          embed.appendChild(video);
          modal.classList.add('is-open');
          modal.removeAttribute('hidden');
          document.body.classList.add('overflow-hidden');
          document.addEventListener('keydown', onKeydown);
          var closeBtn = modal.querySelector('[data-bbj-video-close]');
          if (closeBtn) closeBtn.focus();
        });
      });

      root.querySelector('[data-bbj-video-close]')?.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    scheduleMount(root);
  }

  document.querySelectorAll('[data-bbj-product-videos]').forEach(initRoot);

  document.addEventListener('DOMContentLoaded', function () {
    scheduleMount(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bbj-product-videos]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target) {
      destroySplideIn(event.target);
    }
  });
})();
